export const GET_MEETING_DETAILS = "GET_MEETING_DETAILS";
export const GET_MEETING_DETAILS_INIT = "GET_MEETING_DETAILS_INIT";
export const GET_MEETING_DETAILS_SUCCESS = "GET_MEETING_DETAILS_SUCCESS";
export const GET_MEETING_DETAILS_FAILED = "GET_MEETING_DETAILS_FAILED";
